import WebLayout from "../../layout/WebLayout";
import PanelLayout from "../../layout/PanelLayout";
import { pipGetAccessToken } from "../../utils/pip";
import ContentManagement from "../../components/pages/ContentManagement";

const PrivacyPolicy = () => {
  const { token } = pipGetAccessToken();
  return token ? (
    <PanelLayout>
      {" "}
      <ContentManagement data="Privacy Policy" />
    </PanelLayout>
  ) : (
    <WebLayout>
      {" "}
      <ContentManagement data="Privacy Policy" />
    </WebLayout>
  );
};

export default PrivacyPolicy;
